export default __webpack_public_path__ + "static/media/Kvalitet 1.38456469.jpg";